import { useState } from 'react';
import { Box } from '@mui/material';

import { TabsUI } from '../Interface';
import MaterialPlanLines from './MaterialPlanLines';

const MaterialPlanTabs = ({ disabled }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Anyagterv sorok',
      content: <MaterialPlanLines disabled={disabled} />,
    },
  ];

  return (
    <Box sx={{ my: 4, mt: 6 }}>
      <Box sx={{ px: 1.5 }}>
        <TabsUI activeTab={activeTab} handleTabClick={setActiveTab}>
          {tabs.map((tab, index) => (
            <Box key={index} name={tab.name}>
              {tab.content}
            </Box>
          ))}
        </TabsUI>
      </Box>
    </Box>
  );
};

export default MaterialPlanTabs;
